import script from "./UserPayloadView.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPayloadView.vue?vue&type=script&lang=ts&setup=true"

import "./UserPayloadView.vue?vue&type=style&index=0&id=2e557500&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e557500"]])

export default __exports__